<template>
  <div class="loginContainer">
    <div class="loginTopBox">
      <h1
        class="login logintit"
        :class="[Toggles === 'login'?'loginActive':'']"
        @click="loginShow()"
      >登陆</h1>
      <h2
        class="register logintit"
        :class="[Toggles === 'register'?'loginActive':'']"
        @click="registerShow()"
      >注册</h2>
      <div style="clear:both;"></div>
    </div>

    <div class="loginBox infoBox" v-show="Toggles=='login'">
      <el-form
        :model="loginForm"
        :rules="loginRules"
        ref="loginForm"
        label-width="100px"
        class="loginForm"
      >
        <el-form-item label-width="0" prop="email">
          <el-input
            class="inputStyle"
            v-model="loginForm.email"
            placeholder="邮箱账号"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label-width="0" prop="psw">
          <el-input
            show-password
            type="password"
            class="inputStyle"
            v-model="loginForm.psw"
            placeholder="输入密码"
            autocomplete="new-password"
          ></el-input>
        </el-form-item>
      </el-form>

      <h1 class="toRegister" @click="registerShow()">没有账号，去注册</h1>

      <el-button class="tosubmit" type="primary" @click="submitForm('loginForm')">确 定</el-button>
    </div>

    <div class="registerBox infoBox" v-show="Toggles=='register'">
      <el-form
        :model="registerForm"
        :rules="registerRules"
        ref="registerForm"
        label-width="100px"
        class="registerForm"
      >
        <el-form-item label-width="0" prop="email">
          <el-input
            class="inputStyle"
            v-model="registerForm.email"
            placeholder="邮箱账号"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item label-width="0" prop="psw">
          <el-input
            show-password
            type="password"
            class="inputStyle"
            v-model="registerForm.psw"
            placeholder="输入密码"
            autocomplete="new-password"
          ></el-input>
        </el-form-item>

        <el-form-item label-width="0" prop="checkPass">
          <el-input
            show-password
            class="inputStyle"
            type="password"
            v-model="registerForm.checkPass"
            autocomplete="new-password"
            placeholder="再次输入密码"
          ></el-input>
        </el-form-item>
      </el-form>

      <h1 class="toLogins" @click="loginShow()">已有账号，去登陆</h1>

      <el-button class="toRegists" type="primary" @click="registerTo('registerForm')">确 定</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'loginContainer',
  data() {
    // 验证邮箱
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error('邮箱不能为空'))
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的邮箱格式'))
        }
      }, 100)
    }
    // 验证密码
    var checkPsw = (rule, value, callback) => {
      var patrn = /^(\w){6,20}$/ // 只能输入6-20个字母、数字、下划线
      if (value === '') {
        callback(new Error('请输入密码'))
      } else {
        if (!patrn.exec(value)) {
          callback(new Error('只能输入6-20个字母、数字、下划线 '))
        }
        if (this.registerForm.checkPass !== '') {
          this.$refs.registerForm.validateField('checkPass')
        }
        callback()
      }
    }
    // 再次验证密码
    var checkPsw2 = (rule, value, callback) => {
      var patrn = /^(\w){6,20}$/ // 只能输入6-20个字母、数字、下划线
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (!patrn.exec(value)) {
        callback(new Error('只能输入6-20个字母、数字、下划线 '))
      } else if (value !== this.registerForm.psw) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      Toggles: 'login',
      loginForm: {
        email: '',
        psw: ''
      },
      loginRules: {
        email: [{ validator: checkEmail, trigger: 'blur' }],
        psw: [{ validator: checkPsw, trigger: 'blur' }]
      },
      registerForm: {
        email: '',
        psw: '',
        checkPass: ''
      },
      registerRules: {
        email: [{ validator: checkEmail, trigger: 'blur' }],
        psw: [{ validator: checkPsw, trigger: 'blur' }],
        checkPass: [{ validator: checkPsw2, trigger: 'blur' }]
      }
    }
  },
  created() {},

  // 监听,当路由发生变化的时候执行
  watch: {},

  // 存放所有的事件方法集合
  methods: {
    // 显示登陆
    loginShow() {
      this.Toggles = 'login'
      this.resetForm('loginForm')
    },
    // 显示注册
    registerShow() {
      this.Toggles = 'register'
      this.resetForm('registerForm')
    },
    // 提交检查
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.toLogin(this.loginForm.email, this.loginForm.psw)
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 登录接口
    toLogin(email, psw) {
      const that = this
      const paramObj = {
        loginName: email,
        loginPassword: psw
      }
      /* that.tool.setCookie('username', email, 1) // 储存用户名
      that.$router.replace('/index')
      that.$parent.loginInit() // 调用App.vue中的loginInit方法 */
      this.$server.login(paramObj).then((res) => {
        if (res.code === 200 && res.success) {
          that.tool.setCookie('token', res.cookie_token, 1) // 储存cookie
          that.tool.setCookie('username', res.content.nickName, 1) // 储存用户名
          that.$router.replace('/index')
          that.$parent.loginInit() // 调用App.vue中的loginInit方法
          that.resetForm('loginForm')
          that.$parent.tips(that, '登陆成功', 'success')
        } else {
          that.$message({
            showClose: true,
            message: res.msg
          })
        }
      })
    },
    // 注册检查
    registerTo(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.toRegister()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    // 注册接口
    toRegister() {
      const that = this
      const paramObj = {
        loginName: that.registerForm.email,
        loginPassword: that.registerForm.psw,
        confirmPassword: that.registerForm.checkPass
      }
      this.$server.register(paramObj).then((res) => {
        if (res.code === 200 && res.success) {
          this.toLogin(that.registerForm.email, that.registerForm.psw) // 注册成功后直接跳转至主页
          that.resetForm('registerForm')
        } else {
          that.$message({
            showClose: true,
            message: res.msg
          })
        }
      })
    },
    // 重置登陆/注册信息
    resetForm(formName) {
      this.$refs[formName].resetFields()
    }
  },

  // 页面初始化方法
  mounted() {
    const state = this.$route.params.state // 1===登陆 2===注册
    if (state === 1) {
      this.loginShow()
    } else if (state === 2) {
      this.registerShow()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/css/login.css';
</style>
